<template>
    <van-overlay :show="showed" v-bind="$attrs" :z-index="3000">
        <div class="dialog" @click.stop>
            <div class="title">{{ $t('welcome_gifts_1') }}</div>
            <div class="boom"><img src="@/assets/img/dialog/welcome-gift/bomb.png" /></div>
            <div
                class="num"
                v-html="
                    $t('welcome_gifts_2', {
                        game_type: $t(gameGame.name),
                        current_type: store.cureencySymbol(),
                        number: formatNumber(data.config?.worth || 0, Number.isInteger(data.config?.worth || 0) ? 0 : 2),
                    })
                "
            ></div>
            <div
                class="tip"
                v-html="
                    $t('welcome_info', {
                        number: formatNumber(data.config?.win || 0),
                    })
                "
            ></div>
            <div class="btn" @click="confirm">{{ $t('Claim') }}</div>
        </div>
    </van-overlay>
</template>
<script setup lang="ts">
import popupManager from '@/utils/PopupManager'
import { formatNumber } from '@/utils/toolsValidate'
import { useBaseStore } from '@/stores'
import { getRegistGifts, claimRegistGifts } from '@/api/home'
import { useI18n } from 'vue-i18n'
import eventBus from '@/utils/bus'

const store = useBaseStore()
const i18n = useI18n()

const showed = defineModel()
const regeistData = ref({})

const data = computed(() => {
    const { claimed, config, items } = store.gameList
    if (typeof claimed === 'boolean') {
        return {
            claimed,
            config,
            items,
        }
    }
    return regeistData.value
})
const gameGame = computed(() => {
    const id = data.value?.config?.items[0].id
    if (!id) {
        return {}
    }
    return data.value.items[id]
})
// 选择第一个礼物用于动画效果
const confirm = () => {
    claimRegistGifts().then((res) => {
        if (res.code === 200) {
            showed.value = false
            store.gameList.claimed = true
            // eventBus.emit('bloomAnimate', 1)
            eventBus.emit('bloomAnimate', { type: 1, show: true })
            eventBus.emit('chargeGiftClose')
            // popupManager.delayCheckQueue()
            // popupManager.checkQueue()
        } else {
            store.showFailToast(i18n.t('message_claim_fail'))
        }
    })
}
const getGift = () => {
    const claimed = store.gameList.claimed
    if (claimed) {
        return popupManager.checkQueue()
    }
    if (typeof claimed === 'boolean') {
        showed.value = true
    } else {
        getRegistGifts()
            .then((res) => {
                if (res.code === 200 && !res.data.claimed) {
                    showed.value = true
                    regeistData.value = res.data
                } else {
                    popupManager.checkQueue()
                }
            })
            .catch(() => {
                popupManager.checkQueue()
            })
    }
}

onMounted(() => {
    if (!store.newUser) {
        return popupManager.checkQueue()
    }
    if (store.token) {
        getGift()
    } else {
        popupManager.checkQueue()
    }
})
</script>
<style lang="scss" scoped>
.dialog {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 718px;
    transform: translate3d(-50%, -50%, 0);
    font-family: MicrosoftYaHei;
    text-align: center;

    .title {
        font-size: 72px;
        font-weight: bold;
        line-height: 68px;
        text-align: center;
        color: #fff050;
    }
    .boom {
        position: relative;
        margin: 65px auto 0;
        width: 355px;
        height: 310px;
        img {
            width: 100%;
            height: 100%;
            animation: scale 1s ease infinite alternate;
        }

        &::before {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 525px;
            height: 518px;
            content: '';
            margin-left: -262.5px;
            margin-top: -235px;
            background: url('@/assets/img/dialog/welcome-gift/sun.png') no-repeat;
            background-size: 100% 100%;
            z-index: -1;
            animation: rotate 2.5s linear infinite;
        }
    }
    .num {
        border-radius: 25px;
        font-size: 32px;
        font-weight: bold;
        color: #fff;
        text-align: center;

        :deep(span) {
            color: #ffeb0c;
        }
    }
    .tip {
        padding-left: 40px;
        margin-top: 54px;
        font-size: 24px;
        font-weight: bold;
        line-height: 44px;
        color: #668292;
        text-align: left;

        :deep(span) {
            color: #ffeb0c;
        }
    }
    .btn {
        @apply flex justify-center items-center;
        margin: 88px auto 0;
        width: 565px;
        height: 92px;
        // background-image: linear-gradient(90deg, #26f087 0%, #62ec7c 40%, #9de871 100%);
        // border-radius: 38px;
        // color: #000000;
        // font-size: 40px;
        // font-weight: bold;
        font-size: 44px;
        font-weight: 600;
        font-weight: bold;
        color: #fff;
        border-radius: 100px;
        background: linear-gradient(0deg, #fa3374 0%, #ff7aa5 100%);
        box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.25) inset;
    }
}

@keyframes rotate {
    0% {
        transform: rotateZ(0deg);
    }
    100% {
        transform: rotateZ(360deg);
    }
}
@keyframes scale {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(1.05);
    }
}
</style>
